<template>
  <div style="background-color: white; width: 100%;">
    <div id="container" v-if="applicationID">
      <div v-if="!showReport">
        <div id="sidebar">
          <h2>{{ applicationInfo.title }}</h2>
          <div v-for="(item,index) in questionsInfo" :key="index" 
            @click="switchQuestionIndex(index)"
            :class="[
              currentQuestionIndex == index ? 'selected-question' : null,
              'questionNavBar',
              determineScoreStyleClass(item)
            ]"
          >
            {{ `${index+1}) ${item.question}` }}
          </div>
          <hr style="border: solid black 1px;" />
          <div
            @click="switchQuestionIndex(questionsInfo.length)"
            :class="[
              currentQuestionIndex == questionsInfo.length ? 'selected-question' : null,
              'questionNavBar'
            ]"
            style="text-align: center; font-weight: 700; font-size: 1.2rem"
          >
            Final Page
          </div>
        </div>
        <div id="main-box">
          <div v-if="currentQuestionIndex < questionsInfo.length && questionsInfo.length > 0" id="main-grid">
            <div>
              <span class="prev-ques-nav-buttons">
                <img src="../images/icons_svg/general/left-circle.svg" @click="switchQuestionIndex(currentQuestionIndex - 1)" />
              </span>
              <span class="prev-ques-nav-buttons">
                <img src="../images/icons_svg/general/right-circle.svg" @click="switchQuestionIndex(currentQuestionIndex + 1)" />
              </span>
              <span class="prev-ques-nav-buttons">
                <img src="../images/icons_svg/general/rotate-circle.svg" />
              </span>
            </div>
            <div style="text-align: center;">
              {{ questionsInfo[currentQuestionIndex].question }}
            </div>
            <div style="display: flex; justify-content: center; align-items: center;">
              <span class="preview-icon-container">
                <img src="../images/icons_svg/general/list-search.svg" class='preview-icons'/>
                <div>Previous Results</div>
              </span>
              <span class="preview-icon-container">
                <img src="../images/icons_svg/general/graph.svg" class='preview-icons'/>
                <div>Reports</div>
              </span>
              <span class="preview-icon-container">
                <img src="../images/icons_svg/general/student-graduation.svg" class='preview-icons'/>
                <div>Child View</div>
              </span>
            </div>
            <div style="display: flex; flex-direction: column;">
              <div style="font-size: .9rem;">
                <div style="margin-top: .5rem;">{{ `Q. ${currentQuestionIndex+1}` }}</div>
                <div><span style="margin-top: 1rem; text-decoration: underline;">Area:</span> {{ questionsInfo[currentQuestionIndex].area }}</div>
                <div><span style="margin-top: 1rem; text-decoration: underline;">Type:</span> {{ questionsInfo[currentQuestionIndex].type }}</div>
                <div><span style="margin-top: 1rem; text-decoration: underline;">Category:</span> {{ questionsInfo[currentQuestionIndex].category }}</div>
                <div><span style="margin-top: 1rem; text-decoration: underline;">Subcategory:</span> {{ questionsInfo[currentQuestionIndex].sub_category }}</div>
                <div style="margin-top: 1rem">
                  <span>
                    <span style="text-decoration: underline;">Question ID:</span>
                    ...{{ questionsInfo[currentQuestionIndex].question_id.slice(-4) }}
                  </span>
                  <div>
                    <span>
                      <span style="text-decoration: underline;">Custom QID:</span>
                      ...{{ questionsInfo[currentQuestionIndex].custom_id.slice(-4) }}
                    </span>
                  </div>
                </div>
              </div>
              <div style="display: flex; flex-direction: column;">
                <div v-for="(item, index) in questionsInfo[currentQuestionIndex].specialistButtonsConfig" :key="index">
                  <button v-if="index % 2 === 0" class="exampleButton">{{ item.text }}</button>
                </div>
              </div>
            </div>
            <div class="border-color-primary" id="preview-screen-specialist" :style="{backgroundColor:questionsInfo[currentQuestionIndex].background_color, position: 'relative', height: '500px'}">
              <div v-for="(image, index) in questionsInfo[currentQuestionIndex].child_images" :key="`preview-screen-image${index}`"
                :style="{
                  top: `${image.y}px`,
                  left: `${image.x}px`,
                  width: `${image.width}px`,
                  height: `${image.height}px`,
                  backgroundColor: image.background_color,
                  zIndex: image.zIndex,
                }"
                class="final-image-container"
              >
                <img v-if="image.fileRef" :src="`${reverseProxy}/api/${image.fileRef}`" alt="Picture N/A" width="100%" height="100%"/>
              </div>
              <div v-for="(button, index) in questionsInfo[currentQuestionIndex].child_buttons" :key="`preview-screen-button${index}`"
                :style="{
                  top: `${button.y}px`,
                  left: ` ${button.x}px`,
                  width: `${button.width}px`,
                  height: `${button.height}px`,
                  backgroundColor: button.background_color,
                  zIndex: button.zIndex,
                  fontSize: `${button.fontSize}px`,
                }"
                class="final-button-container"
              >
                <img v-if="button.fileRef" :src="`${reverseProxy}/api/${button.fileRef}`" alt="Picture N/A" width="100%" height="100%"/>
                <div class="placeholder-rect">{{ button.text }}</div>
              </div>
            </div>
            <div style="display: flex; flex-direction: column;">
              <div style="font-size: .9rem; margin: 1rem">
                <div class="typicalDuration">Typ: {{ secondsToInterval(questionsInfo[currentQuestionIndex].typical_duration) }}</div>
                <div class="timeOut">Time Out: {{ secondsToInterval(questionsInfo[currentQuestionIndex].time_out) }}</div>
                <div class="totalDuration">Duration: 0:00</div>
              </div>
              <div class="d-flex flex-column">
                <div v-for="(item, index) in questionsInfo[currentQuestionIndex].specialistButtonsConfig" :key="index">
                  <button v-if="index % 2 !== 0" class="exampleButton">{{ item.text }}</button>
                </div>
              </div>
            </div>
            <div class="icons-grid">
              <span class="preview-icon-container">
                <img src="../images/icons_svg/general/question-circle.svg" class='preview-icons'/>
              </span>
              <span class="preview-icon-container">
                <img src="../images/icons_svg/general/video.svg" class='preview-icons'/>
                <div>Left</div>
              </span>
              <span class="preview-icon-container">
                <img src="../images/icons_svg/general/video-off.svg" class='preview-icons'/>
                <div>Center</div>
              </span>
              <span class="preview-icon-container">
                <img src="../images/icons_svg/general/video.svg" class='preview-icons'/>
                <div>Right</div>
              </span>
              <div class="d-inline-block">
                <div @click="scoreQuestion(questionsInfo[currentQuestionIndex], 0)"
                  :class="[
                    'circle-button',
                    'red-button',
                    0 == questionsInfo[currentQuestionIndex].currentScore ? 'selected-score-button' : null
                  ]"
                >
                  0
                </div>
              </div>
              <div v-for="n in questionsInfo[currentQuestionIndex].highest_score_possible" :key="n" class="d-inline-block">
                <div @click="scoreQuestion(questionsInfo[currentQuestionIndex], n)"
                  :class="[
                    'circle-button',
                    n == questionsInfo[currentQuestionIndex].highest_score_possible ? 'greenFull-button' : 'greenLight-button',
                    n == questionsInfo[currentQuestionIndex].currentScore ? 'selected-score-button' : null
                  ]"
                >
                  {{ `+${n}` }}
                </div>
              </div>
              <span class="preview-icon-container">
                <img src="../images/icons_svg/general/audio-file.svg" class='preview-icons'/>
                <div>Child Prompts</div>
              </span>
              <span class="preview-icon-container">
                <img src="../images/icons_svg/general/info-circle.svg" class='preview-icons'/>
              </span>
              <span class="preview-icon-container">
                <img src="../images/icons_svg/general/list-edit.svg" class='preview-icons'/>
              </span>
              <span class="preview-icon-container">
                <img src="../images/icons_svg/general/lightbulb.svg" class='preview-icons'/>
                <div>Specialist Prompt</div>
              </span>
              <span class="preview-icon-container">
                <img src="../images/icons_svg/general/mike.svg" class='preview-icons'/>
              </span>
              <span class="preview-icon-container">
                <img src="../images/icons_svg/general/camera.svg" class='preview-icons'/>
              </span>
              <span class="preview-icon-container">
                <img src="../images/icons_svg/general/play.svg" class='preview-icons'/>
                <div>Instruction</div>
              </span>
              <span class="preview-icon-container">
                <img src="../images/icons_svg/general/eye-tracking.svg" class='preview-icons'/>
                <div>Eye-tracking</div>
              </span>
              <span class="preview-icon-container">
                <img src="../images/icons_svg/general/head-eeg.svg" class='preview-icons'/>
                <div>EEG</div>
              </span>
              <span class="preview-icon-container">
                <img src="../images/icons_svg/general/arm-emg.svg" class='preview-icons'/>
                <div>EMG</div>
              </span>
              <span class="preview-icon-container">
                <img src="../images/icons_svg/general/heart-pulse.svg" class='preview-icons'/>
                <div>ECG</div>
              </span>
              <span class="preview-icon-container">
                <img src="../images/icons_svg/general/augment-reality.svg" class='preview-icons'/>
                <div>Augmented Reality</div>
              </span>
              <span class="preview-icon-container">
                <img src="../images/icons_svg/general/virtual-reality.svg" class='preview-icons'/>
                <div>Virtual Reality</div>
              </span>
            </div>
          </div>
          <div v-else id="finish-box">
            <div><button style="width: 100%;" @click="showReportToggle">Continue to Report</button></div>
            <span v-for="(item,index) in questionsInfo" :key="index" 
              @click="switchQuestionIndex(index)"
              :class="[
                'finish-quesiton-squares',
                determineScoreStyleClass(item)
              ]"
              :style="{
                backgroundColor: item.currentScore == null ? '#ECECEC' : ''           
              }"
            >
              {{ index+1 }}
            </span>
          </div>
        </div>
      </div>
      <div v-else>
        <ConfigureReportNewApp :applicationID="applicationID" @backToAppConfig="backToAppConfig"/>
      </div>
    </div>
  </div>
</template>

<script>
  import instance from '../axios';
  import ConfigureReportNewApp from './subComponents/ConfigureReportNewApp.vue';

  export default {
    components:{
      ConfigureReportNewApp
    },
    data() {
      return {
        reverseProxy: process.env.VUE_APP_REVERSE_PROXY_ENDPOINT,
        applicationID: null,
        applicationInfo: null,
        questionsInfo: null,
        currentQuestionIndex: -1,
        showReport: false
      }
    },
    async created() {
      function placeInArray(arr, value, variableToCheck, findOrder) {
        let low = 0;
        let high = arr.length - 1;
        // Binary search to find the insertion point
        while (low <= high) {
          const mid = Math.floor((low + high) / 2);
          if (arr[mid][variableToCheck] < findOrder) {
            low = mid + 1;
          } else {
            high = mid - 1;
          }
        }

        // If the value is not in the array, insert it at the correct position
        arr.splice(low, 0, value);
        return arr;
      }
      try {

        let applicationResponse = await instance.get(`/api/appAdmin/application/${this.$route.params.applicationID}`);
        this.applicationInfo = applicationResponse.data;
        let questionsReseponse = await instance.get(`/api/question-admin/application/${this.$route.params.applicationID}`);
        let data = questionsReseponse.data;
        let result = [];

        for (let i = 0; i < data.length; i++) {
          placeInArray(result, {
            ...data[i],
            child_buttons: JSON.parse(data[i].child_buttons),
            specialist_buttons: JSON.parse(data[i].specialist_buttons),
            child_images: JSON.parse(data[i].child_images),
            time_out: this.intervalToSeconds(data[i].time_out),
            typical_duration: this.intervalToSeconds(data[i].typical_duration),

            currentScore: null
          }, 'question_order', data[i].question_order);
        }
        this.questionsInfo = result;
        this.applicationID = this.$route.params.applicationID;

        if (data.length > 0) {
          this.currentQuestionIndex = 0;
          this.formatForNewResolution('preview-screen-specialist');
        }
      } catch (e) {
        console.error(e);
      }
    },
    methods: {
      switchQuestionIndex(index) {
        if (index < 0) {
          return;
        }
        this.currentQuestionIndex = index;
        if (index < this.questionsInfo.length) {
          this.formatForNewResolution('preview-screen-specialist');
        }
      },
      showReportToggle() {
        this.showReport = !this.showReport;
      },
      backToAppConfig() {
        this.showReportToggle();
      },
      secondsToInterval(seconds) {
        const h = Math.floor(seconds / 3600);
        const m = Math.floor((seconds % 3600) / 60);
        const s = seconds % 60;
        return `${h}:${m}:${s}`;
      },
      intervalToSeconds(interval) {
        const [h, m, s] = interval.split(":").map(Number);
        return h * 3600 + m * 60 + s;
      },
      getImageFileSrc(imageDetailObject) {
        if (imageDetailObject.fileRef != null && imageDetailObject.fileRef != "") {
          return imageDetailObject.fileRef;
        } else if (imageDetailObject.file != null) {
          return URL.createObjectURL(imageDetailObject.file);
        } else {
          return null;
        }
      },
      scoreQuestion(question, currentScore) {
        this.$forceUpdate()
        question.currentScore = currentScore;
      },
      determineScoreStyleClass(question) {
        if (question.currentScore == null) {
          return '';
        } else if (question.currentScore == question.highest_score_possible) {
          return 'score-greenFull';
        } else if (question.currentScore == 0) {
          return 'score-zero';
        } else {
          return 'score-greenLight';
        }
      },
      formatTime(totalSeconds) {
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;
        return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
      },
      formatForNewResolution(elementID) {
        this.$nextTick(() => {
          if (!document.getElementById(elementID)) {
            return;
          }

          let currentQuestionInstance = this.questionsInfo[this.currentQuestionIndex];
          let [originalWidth, originalHeight] = currentQuestionInstance.child_view_original_screen_resolution.split('x').map(Number);
          let newWidth = document.getElementById(elementID).offsetWidth;
          let newHeight = document.getElementById(elementID).offsetHeight;
          if (newWidth == originalWidth && newHeight == originalHeight) {
            return;
          }

          //[x,y] transform coordinates from original to new resolution
          let xTransform = newWidth / originalWidth;
          let yTransform = newHeight / originalHeight;

          for (let i = 0; i < currentQuestionInstance.child_buttons.length; i++) {
            currentQuestionInstance.child_buttons[i].x *= xTransform;
            currentQuestionInstance.child_buttons[i].y *= yTransform;
            currentQuestionInstance.child_buttons[i].height *= yTransform;
            currentQuestionInstance.child_buttons[i].width *= xTransform;
          }

          for (let i = 0; i < currentQuestionInstance.child_images.length; i++) {
            currentQuestionInstance.child_images[i].x *= xTransform;
            currentQuestionInstance.child_images[i].y *= yTransform;
            currentQuestionInstance.child_images[i].height *= yTransform;
            currentQuestionInstance.child_images[i].width *= xTransform;
          }

          currentQuestionInstance.child_view_original_screen_resolution = `${newWidth}x${newHeight}`;
        });

      },
      startStopWatch(questionFunctions, stopWatchName, stopWatchElapseTimeName) {
        //questionFunctions is Object
        questionFunctions[stopWatchName] = setInterval(() => {
          questionFunctions[stopWatchElapseTimeName]++;
        }, 1000);
      },
      stopStopWatch(questionFunctions, stopWatchName) {
        //questionFunctions is Object
        clearInterval(questionFunctions[stopWatchName]);
        questionFunctions[stopWatchName] = null;
      },
      resetStopWatch(questionObject, stopWatchName, stopWatchElapseTimeName) {
        let questionFunctions = questionObject;
        questionFunctions[stopWatchElapseTimeName] = 0;
        this.stopStopWatch(questionFunctions, stopWatchName);
        this.startStopWatch(questionFunctions, stopWatchName, stopWatchElapseTimeName);
      },
      startTimer(questionFunctions, timerName, timerElapseTimeName) {
        //questionFunctions is Object
        questionFunctions[timerName] = setInterval(() => {
          let temp = questionFunctions[timerElapseTimeName];
          if (temp - 1 < 0) {
            this.stopTimer(questionFunctions, timerName);
          }
          else {
            questionFunctions[timerElapseTimeName]--;
          }
        }, 1000);
      },
      stopTimer(questionFunctions, timerName) {
        //questionFunctions is Object
        clearInterval(questionFunctions[timerName]);
        questionFunctions[timerName] = null;
      },
      resetTimer(questionObject, timerName, timerElapseTimeName, originalTimeName) {
        let questionFunctions = questionObject;
        questionFunctions[timerElapseTimeName] = questionObject[originalTimeName];
        this.stopTimer(questionFunctions, timerName);
        this.startTimer(questionFunctions, timerName, timerElapseTimeName);
      },
      previewTimingPack(questionObject, setting) {
        let questionFunctions = questionObject;
        //turn on timings
        if (setting) {
          this.startTimer(questionFunctions, 'typicalDurationTimer', 'typicalDurationTimerElapsedTime');
          this.startTimer(questionFunctions, 'timeOutTimer', 'timeOutTimerElapsedTime');
          this.startStopWatch(questionFunctions, 'questionDuration', 'questionDurationTimerElapse');
        }
        else {
          this.stopTimer(questionFunctions, 'typicalDurationTimer');
          this.stopTimer(questionFunctions, 'timeOutTimer');
          this.stopStopWatch(questionFunctions, 'questionDuration');
        }
      },
      previewTimingResetPack(questionObject) {
        this.resetTimer(questionObject, 'typicalDurationTimer', 'typicalDurationTimerElapsedTime', 'typicalDuration');
        this.resetTimer(questionObject, 'timeOutTimer', 'timeOutTimerElapsedTime', 'timeOut');
        this.resetStopWatch(questionObject, 'questionDuration', 'questionDurationTimerElapse');
      },
    }
  }
</script>

<style lang="scss" scoped>
  @use 'sharedSCSS/_globalSharedVariables';

  $sidebar-width: 300px;
  $reportOrange: #FF9B00;
	$reportOrangeLight: #eecc9a;
  $greenFull: #ace2c6;
  $greenLight: #D9F2E6;
  $redZero: #FFBCBC;

  #container {
    font-family: 'Roboto', sans-serif;
    width: 100%;
    position: relative;

    h2 {
      text-align: center;
    }

    .score-greenFull {
      background-color: $greenFull;
    }

    .score-greenLight {
      background-color: $greenLight;
    }

    .score-zero {
      background-color: $redZero;
    }
  }

  #sidebar {
    border-right: solid $reportOrange 1px;
    width: $sidebar-width;
    position: fixed;
    overflow-y: scroll;
    height: calc(100dvh - #{globalSharedVariables.$navbar-height});

    .questionNavBar {
      cursor: pointer;
      padding: .5rem;

      &:hover {
        background-color: $reportOrangeLight;
      }
    }

    .selected-question {
      background-color: $reportOrange;
    }
  }

  #main-box {
    margin-left: $sidebar-width;
    padding: 1rem;

    #main-grid {
      display: grid;
      grid-template-columns: 1fr 3fr 1fr;

      .prev-ques-nav-buttons {
        cursor: pointer;
        padding: 0;
        margin: 0 2px;

        img {
          width: 30px;
          border-radius: 50rem;

          &:hover {
            background-color: $reportOrange;
          }
        }
      }

      .border-color-primary {
        border: solid 2px $reportOrange;
        width: 100%;
        position: relative;

        > div {
          position: absolute;
        }

        .resizable-button-container, .final-button-container {
          $local-border-radius: 1rem;

          position: absolute;
          border-radius: $local-border-radius;
          box-shadow: 0 0 5px 5px lightgrey;
          border: solid black 1px;
          user-select: none;
          cursor: pointer;
          
          .placeholder-rect {
            position: absolute;
            top: 0;
            left: 0;
            word-wrap: break-word;
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
          }

          img {
            border-radius: $local-border-radius;
          }
        }
      }

      .icons-grid {
        margin-top: 1rem;
        grid-column: span 3;
        display: grid;
        grid-template-columns: repeat(11, auto);
      }

      .preview-icon-container {
        font-size: xx-small;
        text-align: center;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        height: 50px;
        width: 50px;
        cursor: pointer;

        .preview-icons {
          width: 50px;
          height: 24px;
        }

        &:hover {
          opacity: .8;
        }

        div {
          position: absolute;
          left: 50%;
          bottom: 0;
          transform: translate(-50%, 50%);
        }
      }

      .circle-button {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
      }

      .greenFull-button {
        box-shadow: inset 0 0 2px 2px $greenFull;
        color: $greenFull;
        border: 1px solid green;
        -webkit-text-stroke: 1px black;

        &:hover {
          background-color: $greenFull;
        }

        &.selected-score-button {
          background-color: $greenFull;
        }
      }

      .greenLight-button {
        box-shadow: inset 0 0 2px 2px $greenLight;
        color: $greenLight;
        border: 1px solid rgb(0, 156, 0);
        -webkit-text-stroke: 1px black;

        &:hover {
          background-color: $greenLight;
        }

        &.selected-score-button {
          background-color: $greenLight;
        }
      }

      .red-button {
        box-shadow: inset 0 0 2px 2px $redZero;
        color: $redZero;
        border: 1px solid red;
        -webkit-text-stroke: 1px black;

        &:hover {
          background-color: $redZero;
        }

        &.selected-score-button {
          background-color: $redZero;
        }
      }
    }

    #finish-box {
      .finish-quesiton-squares {
        cursor: pointer;
        margin: .3rem;
        width: 50px;
        height: 50px;
        border-radius: 5px;
        border: solid black 1px;
        display: inline-flex;
        justify-content: center;
        align-items: center;
      }
    }

    .typicalDuration {
      border: solid #FAFD5F 2px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .timeOut {
      border: solid #2B870B 2px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 1rem;
    }

    .totalDuration {
      border: solid black 2px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 1rem;
    }

  }
</style>